<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 912 183"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="servier" clip-path="url(#clip0_1_85)">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M355.083 62.6815C358.293 39.7978 345.355 23.5984 312.962 23.5984H254.594L238.348 139.124H269.228L274.218 103.671H293.254L311.868 139.124H347.556L325.563 98.6958C342.566 91.8713 352.63 80.1281 355.097 62.6815H355.083ZM323.671 65.232C322.395 74.3546 314.868 79.7918 303.542 79.7918H277.568L281.731 50.1256H307.327C317.223 50.1256 325.241 53.9933 323.657 65.232H323.671Z"
            :fill="props.fill"
          />
          <path
            id="Vector_2"
            d="M452.307 23.5984L414.516 99.2423L397.99 23.5984H363.325L393.855 139.11H422.912L486.144 23.5984H452.307Z"
            :fill="props.fill"
          />
          <path
            id="Vector_3"
            d="M482.289 139.11H513.337L529.583 23.5984H498.521L482.289 139.11Z"
            :fill="props.fill"
          />
          <path
            id="Vector_4"
            d="M65.9649 45.1649C77.1646 45.1649 87.1168 48.8083 96.7887 55.5207L115.221 35.0753C104.316 26.373 87.6915 20.2632 69.5252 20.2632C36.2484 20.2632 18.4606 36.883 15.6993 56.3335C13.1201 74.4948 20.7454 84.262 53.4475 92.5439C72.553 97.3785 77.9776 99.9289 76.9824 106.529C76.1273 112.331 69.7075 116.759 55.8865 116.759C41.1965 116.759 31.1322 113.017 19.6661 103.839L0 122.855C13.022 134.584 30.4593 141.689 52.5644 141.689C95.9897 141.689 108.115 117.249 109.741 105.786C113.091 82.118 100.952 75.4196 69.9317 67.9505C48.0089 62.6675 46.2567 59.8789 47.0557 54.5118C48.0229 48.0516 54.2045 45.1789 65.9368 45.1789L65.9649 45.1649Z"
            :fill="props.fill"
          />
          <path
            id="Vector_5"
            d="M851.796 110.957C845.32 137.835 821.645 155.408 795.629 155.408C778.612 155.408 766.418 146.873 759.157 133.547L740.191 98.7097C757.054 91.9413 767.259 80.2682 769.726 62.6955C772.935 39.8117 759.998 23.6123 727.604 23.6123H669.236L652.99 139.138H683.87L688.86 103.684H707.896L726.721 139.559C744.172 172.84 767.497 183 795.629 183C837.751 183 874.798 154.805 881.989 110.985H851.796V110.957ZM738.313 65.2459C737.038 74.3686 729.51 79.8057 718.184 79.8057H692.211L696.374 50.1395H721.969C731.865 50.1395 739.883 54.0072 738.299 65.2459H738.313Z"
            :fill="props.fill"
          />
          <path
            id="Vector_6"
            d="M123.197 139.11H215.724L219.299 113.83H156.25L159.305 92.1936H215.738L218.934 69.6742H162.501L165.459 48.8784H227.681L231.27 23.5984H139.555L123.197 139.11Z"
            :fill="props.fill"
          />
          <path
            id="Vector_7"
            d="M538.61 139.11H631.152L634.726 113.83H571.663L574.733 92.1936H631.166L634.362 69.6742H577.929L580.872 48.8784H643.108L646.683 23.5984H554.982L538.61 139.11Z"
            :fill="props.fill"
          />
        </g>
        <path
          id="Vector_8"
          d="M866.893 0L875.99 20.8098L896.329 10.7062L889.923 32.4969L912 37.836L893.077 50.3919L906.561 68.6653L883.98 66.1429L882.564 88.8024L866.893 72.3508L851.236 88.8024L849.82 66.1429L827.238 68.6653L840.723 50.3919L821.8 37.836L843.877 32.4969L837.457 10.7062L857.81 20.8098L866.893 0Z"
          :fill="props.fill"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_85">
        <rect width="912" height="183" :fill="props.fill" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: 912
  },
  height: {
    type: [Number, String],
    default: 183
  },
  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
